import {
  EnvironmentProviders,
  inject,
  provideEnvironmentInitializer,
} from '@angular/core';
import { SeoRouteSyncService } from './seo-route-sync.service';

export function provideSeoRouting(): EnvironmentProviders {
  return provideEnvironmentInitializer(() => {
    // Force construction so it subscribes to NavigationEnd and applies SEO
    inject(SeoRouteSyncService);
  });
}
